export const isNationalReferrer = (): boolean => {
  return document.referrer.startsWith(`${window.location.origin}/national`);
};
